
export default function CommonService() {

    function DecodeNodeId(rawData: string) {
        const decoded = atob(rawData); // atob decodes base64
        const splitRes = JSON.parse(decoded); // Split by ":" to get the table and id
        return splitRes[3];
    }

    return {
        DecodeNodeId,
    };
} 